<template>
  <div class="markets-position">
    <div class="markets-position-container">
      <div>
        <img src="@/images/investment/cube.png" class="image-title" />
      </div>
      <div class="subtext-1">
        5,000x return of investment
      </div>
      <h1>
        OOYYO holds strong position in over 20 markets.<br />
        We expect to either go public, or be acquired at a $1B valuation.
      </h1>
      <div class="row subcontent-wrapper">
        <div class="col-4">
          <p>
            <strong class="fw-bold text-white text-uppercase">CARVANA</strong> -
            Valuated at $51B
          </p>
          <p>
            <strong class="fw-bold text-white text-uppercase">OOYYO</strong> -
            Expected to reach over $1B valuation <br> 
            <small>For a limited time, OOYYO will give investors the 
            opportunity to invest in it’s top used car sales
            technology/internet company.
            </small>
          </p>
          <p>
            <strong class="fw-bold text-white text-uppercase">TRUECAR</strong> -
            Valuated at $550M
          </p>
        </div>
        <div class="col-8">
          <img
            src="@/images/investment/browserwindow.png"
            class="image-content"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
